export const SET_SELECTED_VEHICLE = 'valetv2/prebooking/setSelectedVehicle';
export const SET_SELECTED_PROJECT = 'valetv2/prebooking/setSelectedProject';
export const SET_SELECTED_DATE = 'valetv2/prebooking/setSelectedDate';
export const SET_PROJECTS = 'valetv2/prebooking/setProjects';
export const SET_RECENT_PROJECTS = 'valetv2/prebooking/setRecentProjects';
export const SET_NEARBY_PROJECTS = 'valetv2/prebooking/setNearbyProjects';
export const SET_ALL_PROJECTS = 'valetv2/prebooking/setAllProjects';
export const SET_BOOKINGS = 'valetv2/prebooking/setBookings';

export const SET_STATIC_BOOKING_DETAILS =
  'valetv2/booking/setStaticBookingDetails';
export const SET_DYNAMIC_BOOKING_DETAILS =
  'valetv2/booking/setDynamicBookingDetails';

export const SET_PAYMENT_HISTORY_CONTAINER =
  'valetv2/booking/setPaymentHistoryContainer';

  export const SET_REFERRAL_CODE = 'valetv2/booking/setReferralCode'
